import { render } from "./ViewRevisions.vue?vue&type=template&id=31006eea&scoped=true"
import script from "./ViewRevisions.vue?vue&type=script&lang=js"
export * from "./ViewRevisions.vue?vue&type=script&lang=js"

import "./ViewRevisions.vue?vue&type=style&index=0&id=31006eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31006eea"]])

export default __exports__